import { CookieStore } from "@common/core/CookieStore";
import { type BookmarkType, BookmarkTypes } from "./bookmarks-config";

export const BookmarksMetaCookieKeyName = "bookmark_meta";

export const init = () => {
  reviewBookmarkNavState();
  window.addEventListener("bookmarks-metadata", (e) => setBookmarkMetadataCookie(e.detail));
};
/**
 * Reviews bookmark meta and actions the state (orange dot or not to orange dot)
 */
export const reviewBookmarkNavState = () => {
  const metadata = getBookmarkMetadataFromCookie();
  if (!metadata) return;

  const totalBookmarks = getBookmarkTotalFromMetadata(metadata);
  setBookmarkNavButtonState(totalBookmarks > 0);
};

/**
 * Sets/unsets active class on bookmark nav icon
 */
export const setBookmarkNavButtonState = (state: boolean) => {
  const bookmarkNavButton = document.getElementById("user-bookmarks-status");
  if (!bookmarkNavButton) {
    return;
  }
  if (state) {
    bookmarkNavButton.classList.add("active");
  } else {
    bookmarkNavButton.classList.remove("active");
  }
};

/**
 * Get total number of bookmarks saved from metadata object
 */
export const getBookmarkTotalFromMetadata = (metadata: BookmarkMeta): number => {
  let totals = 0;
  Object.keys(metadata).map((typeTotal) => {
    totals = totals + Number(metadata[typeTotal as keyof BookmarkMeta]);
  });

  return totals;
};

/**
 * Returns bookmark metadata from cookie or false if not found
 */
type BookmarkMeta = {
  jobTotal: number;
  volunteeringTotal: number;
  courseTotal: number;
  articleTotal: number;
  traveldealTotal: number;
};
export const getBookmarkMetadataFromCookie = (): BookmarkMeta | false => {
  const metadataCookie = CookieStore.getCookie(BookmarksMetaCookieKeyName) ?? "{}";
  try {
    const metadata = JSON.parse(metadataCookie);
    return validateBookmarkMeta(metadata) ? metadata : false;
  } catch (e) {
    return false;
  }
};

/**
 * Validates the bookmark totals metadata
 */
export const validateBookmarkMeta = (metadata: any) => {
  let metaValidate = true;
  BookmarkTypes.forEach((type) => {
    if (typeof metadata[type + "Total"] === "undefined" || !Number.isInteger(metadata[type + "Total"])) {
      // Data not in correct format
      metaValidate = false;
    }
  });
  return metaValidate;
};

export const incrementBookmarkMetaby1 = (type: BookmarkType) => {
  const metadata = getBookmarkMetadataFromCookie();
  if (!metadata) {
    return;
  }

  const key: keyof BookmarkMeta = `${type}Total`;
  metadata[key] = metadata[key] + 1;
  setBookmarkMetadataCookie(metadata);
  animateBookmarkHeart();
};

export const reduceBookmarkMetaby1 = (type: BookmarkType) => {
  const metadata = getBookmarkMetadataFromCookie();
  if (!metadata) {
    return;
  }
  const key: keyof BookmarkMeta = `${type}Total`;
  metadata[key] = metadata[key] - 1;
  setBookmarkMetadataCookie(metadata);
};

/**
 * Adds class to animate a change on the nav bookmark button
 */
export const animateBookmarkHeart = () => {
  const bookmarkNavButton = document.getElementById("user-bookmarks-status");
  bookmarkNavButton?.classList.add("animate-change");
  setTimeout(() => {
    bookmarkNavButton?.classList.remove("animate-change");
  }, 2000);
};

/**
 * Sets Bookmark metadata cookie if valid
 */
export const setBookmarkMetadataCookie = (metadata: Record<string, any>): void => {
  if (!validateBookmarkMeta(metadata)) {
    return;
  }
  CookieStore.setCookie(BookmarksMetaCookieKeyName, JSON.stringify(metadata), {
    secure: true
  });

  reviewBookmarkNavState();
};
